import {
    CustomerNotificationActionTypes,
    CustomerNotificationActions,
    CustomerNotificationStateType,
} from '../constant/notification.const'

const initialState: CustomerNotificationStateType = {
    successDataExecuted: null,
}

function customerNotificationReducers(
    state = initialState,
    actions: CustomerNotificationActions
): CustomerNotificationStateType {
    switch (actions.type) {
        case CustomerNotificationActionTypes.setSuccessDataExecuted:
            return { ...state, successDataExecuted: actions.payload }

        default:
            return state
    }
}

export default customerNotificationReducers
